export const currencyParser = (value: string) =>
    value.length > 0 ? value.replace(/MYR\s?|(,*)/g, '') : ''

export const currencyFormatter = (value: number) =>
    value > 0 ? `MYR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
